import styled from 'styled-components';

export const Paragraph = styled.p`
  color: #ec3237 !important;
  font-size: 0.9rem;
`;
